import { defaultTrainAuth } from '@train-protocol/auth';
import { defaultTrainSDK } from '@train-protocol/sdk';
import { FuelHTLCPublicClient, FuelHTLCWalletClient } from './client/index.js';
import { deriveKeyFromFuelWallet } from './login/index.js';
export { FuelHTLCPublicClient, FuelHTLCWalletClient } from './client/index.js';
export { deriveKeyFromFuelWallet } from './login/index.js';
export function registerFuelSdk(sdk, auth) {
    const s = sdk ?? defaultTrainSDK;
    const a = auth ?? defaultTrainAuth;
    s.registerHTLCPublicClient('fuel', config => new FuelHTLCPublicClient(config));
    s.registerHTLCWalletClient('fuel', config => new FuelHTLCWalletClient(config));
    a.registerWalletSign('fuel', async (config) => deriveKeyFromFuelWallet(config.wallet));
}
